<template>

    <div class="lw-course-contents-chapter lw-b-1px-fadeout90 mb-6rem" @click="sectionClicked" :class="sectionWrapperClass">
        <div class="with-flexible-parts justify-content-space-between lw-bb-1px-fadeout90 p-2rem align-items-center">
            <h3 class="learnworlds-heading3 learnworlds-heading3-large learnworlds-element lw-course-contents-chapter-name no-margin-bottom">{{sectionTitle}}</h3>
            <div class="lw-tag no-margin-bottom lw-brand-bg learnworlds-main-text learnworlds-element learnworlds-main-text-tiny" v-if="displayAccessLabel && sectionAccess !== 'premium'">{{sectionDisplayedAccessLabel}}</div>

            <!-- drip feed -->
            <div class="ml-20px with-flexible-parts align-items-center" v-if="dripFeedTagsDisplay">
                <span class="mr-10px small learnworlds-icon no-margin-bottom fas fa-lock"></span>
                <div class="lw-tag no-margin-bottom lw-brand-bg learnworlds-main-text learnworlds-element learnworlds-main-text-tiny">{{sectionDripDateLabel}}</div>
            </div>
            <!----->

        </div>

        <div v-if="sectionDescription" class="pl-2rem mt-2rem mb-2rem learnworlds-main-text-large">{{ sectionDescription }}</div>

        <div class="p-2rem">
            <div class="with-flexible-parts align-items-center" v-if="sectionUnitsCountLabel">
                <span class="no-margin-bottom small learnworlds-icon fas fa-file-alt"></span>
                <div class="ml-10px no-margin-bottom learnworlds-main-text learnworlds-main-text-small learnworlds-element">
                    {{sectionUnitsCountLabel}}
                </div>
                <a class="ml-10px no-margin-bottom learnworlds-main-text learnworlds-main-text-small learnworlds-element" @click="emitAction('set-section-display' , !sectionDisplay)" >
                    {{ sectionDisplay ? 'Show less' : 'Show more' }}
                </a>
            </div>
            <div class="pl-2rem mt-1rem lw-course-contents-units" v-show="sectionDisplay">
                <div class="lw-course-contents-unit with-flexible-parts align-items-center p-5px-0" v-for="unit,index in sectionUnits" @click="unitClicked(unit,...arguments)">
                    <unit-icon class="lw-contents-svg small" :icon="unit.icon"></unit-icon>

                    <div class="ml-10px no-margin-bottom learnworlds-main-text learnworlds-main-text-small learnworlds-element">
                        {{unit.title}}
                    </div>
                    <div class="hide-sp ml-10px no-margin-bottom lw-text-color-fadeout50 learnworlds-main-text learnworlds-main-text-small learnworlds-element" v-if="getFullUnitData(unit) && getUnitExtraInfo(unit)">
                        {{getUnitExtraInfo(unit)}}
                    </div>
                    <span class="ml-10px no-margin-bottom learnworlds-main-text-small learnworlds-icon fas fa-paperclip" v-if="unit.attachments && unit.attachments.length"></span>
                    <span class="ml-10px no-margin-bottom learnworlds-main-text-small learnworlds-icon fas fa-check" v-if="unitCompleted(unit)"></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CourseContentsTemplateMixin from "../../mixins/CourseContentsTemplateMixin";
    import ComponentTemplatesMixin from "../../mixins/ComponentTemplatesMixin";

    export default {
        name: "CourseContentsTemplate20",
        mixins: [CourseContentsTemplateMixin,ComponentTemplatesMixin],
        props: {
            sectionsDisplay: {
                type: Object
            }
        },
        computed: {
            sectionDisplay () {
                return this.sectionsDisplay && this.sectionsDisplay[this.sectionData.titleId] ? true : false;
            }
        }
    }
</script>

